import "./About.css";
import pic1 from "../pics/myPic.png";
import React, { useEffect } from "react";
// import { Parallax } from "react-scroll-parallax";
import { FiExternalLink } from "react-icons/fi";
// import anime from "animejs/lib/anime.es.js";
function About() {
  // useEffect(()=>{
  //   anime({
  //     targets: "#aboutAnime path",
  //     strokeDashoffset: [anime.setDashoffset, 0],
  //     easing: "easeInOutSine",
  //     duration: 1500,
  //     delay: function (el, i) {
  //       return i * 200;
  //     },
  //     direction: "alternate",
  //     loop: true,
  //   });
  // },[])
  return (
    <div className="about" id="about">
      {/* <Parallax translateX={[0,0]} speed={10}>
        {" "}
      </Parallax> */}
      <h1 className="text-center about-head ">ABOUT ME</h1>
      {/* <div>
        <svg
        id="aboutAnime"
          width="641.76"
          height="87.242"
          viewBox="0 0 641.76 87.242"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="svgGroup"
            stroke-linecap="round"
            fill-rule="evenodd"
            font-size="9pt"
            stroke="#000000"
            stroke-width="0.6mm"
            fill="none"
            // style="stroke:#000000;stroke-width:0.2mm;fill:none"
          >
            <path
              d="M 64.68 86.401 L 62.76 73.561 L 34.44 73.561 L 27.96 86.401 L 0 86.401 L 46.08 1.441 L 76.8 1.441 L 92.76 86.401 L 64.68 86.401 Z M 44.52 53.521 L 59.88 53.521 L 56.4 29.881 L 44.52 53.521 Z"
              id="0"
              vector-effect="non-scaling-stroke"
            />
            <path
              d="M 143.28 86.401 L 98.76 86.401 L 113.76 1.441 L 157.08 1.441 A 47.878 47.878 0 0 1 163.782 1.88 Q 167.301 2.379 170.179 3.443 A 21.19 21.19 0 0 1 175.02 5.941 A 14.51 14.51 0 0 1 181.283 16.482 A 20.867 20.867 0 0 1 181.44 19.081 A 26.816 26.816 0 0 1 181.326 21.485 A 34.801 34.801 0 0 1 181.08 23.521 A 25.329 25.329 0 0 1 178.286 31.531 A 22.921 22.921 0 0 1 174.96 36.061 Q 170.16 41.161 163.44 42.841 A 19.754 19.754 0 0 1 168.143 44.637 A 14.939 14.939 0 0 1 172.98 48.781 A 16.398 16.398 0 0 1 176.264 58.221 A 20.409 20.409 0 0 1 176.28 59.041 Q 176.28 60.961 175.92 63.121 A 28.765 28.765 0 0 1 172.913 72.049 A 24.492 24.492 0 0 1 165.54 80.341 Q 158.104 85.667 146.544 86.312 A 58.605 58.605 0 0 1 143.28 86.401 Z M 143.4 53.041 L 131.28 53.041 L 129.24 65.041 L 141.36 65.041 Q 144.96 65.041 146.94 63.661 A 5.35 5.35 0 0 0 148.745 61.446 Q 149.116 60.639 149.316 59.635 A 10.799 10.799 0 0 0 149.4 59.161 A 5.198 5.198 0 0 0 149.468 58.706 Q 149.52 58.231 149.52 57.601 Q 149.52 53.646 144.916 53.121 A 13.422 13.422 0 0 0 143.4 53.041 Z M 147 22.561 L 136.68 22.561 L 134.52 34.561 L 144.84 34.561 A 14.538 14.538 0 0 0 147.035 34.406 Q 148.169 34.232 149.093 33.864 A 6.677 6.677 0 0 0 150.48 33.121 A 5.768 5.768 0 0 0 152.547 30.406 A 8.538 8.538 0 0 0 153 28.681 A 5.198 5.198 0 0 0 153.068 28.226 Q 153.12 27.751 153.12 27.121 A 6.048 6.048 0 0 0 152.988 25.812 Q 152.803 24.979 152.36 24.373 A 3.293 3.293 0 0 0 151.62 23.641 Q 150.2 22.618 147.327 22.564 A 17.292 17.292 0 0 0 147 22.561 Z"
              id="1"
              vector-effect="non-scaling-stroke"
            />
            <path
              d="M 212.488 86.165 A 44.491 44.491 0 0 0 222.48 87.241 Q 237.36 87.241 248.82 80.641 Q 260.28 74.041 266.58 62.161 A 52.095 52.095 0 0 0 270.996 50.729 A 62.101 62.101 0 0 0 272.88 35.161 A 44.666 44.666 0 0 0 272.529 29.483 A 35.118 35.118 0 0 0 268.44 16.741 Q 264 8.761 255.78 4.381 A 35.95 35.95 0 0 0 246.25 0.963 A 47.019 47.019 0 0 0 236.52 0.001 Q 221.76 0.001 210.42 6.541 Q 199.08 13.081 192.78 24.781 Q 186.48 36.481 186.48 51.721 A 45.261 45.261 0 0 0 186.766 56.871 A 36.109 36.109 0 0 0 190.92 70.261 Q 195.36 78.361 203.52 82.801 A 35.147 35.147 0 0 0 212.488 86.165 Z M 226.56 62.401 A 19.851 19.851 0 0 0 232.649 61.497 A 17.176 17.176 0 0 0 237.42 59.101 Q 242.04 55.801 244.44 50.341 A 28.831 28.831 0 0 0 246.83 39.337 A 33.258 33.258 0 0 0 246.84 38.521 Q 246.84 31.921 243.3 28.261 A 11.439 11.439 0 0 0 238.017 25.205 Q 235.841 24.601 233.16 24.601 Q 226.92 24.601 222.24 27.841 A 20.648 20.648 0 0 0 215.119 36.498 A 24.403 24.403 0 0 0 215.1 36.541 A 28.29 28.29 0 0 0 212.645 47.766 A 32.565 32.565 0 0 0 212.64 48.361 Q 212.64 53.81 215.053 57.296 A 11.505 11.505 0 0 0 216.18 58.681 A 11.283 11.283 0 0 0 221.207 61.689 Q 222.977 62.223 225.103 62.356 A 23.249 23.249 0 0 0 226.56 62.401 Z"
              id="2"
              vector-effect="non-scaling-stroke"
            />
            <path
              d="M 289.92 1.441 L 316.44 1.441 L 308.04 49.321 Q 307.68 51.241 307.68 53.281 Q 307.68 57.361 309.84 59.701 A 6.579 6.579 0 0 0 312.497 61.409 Q 313.565 61.794 314.884 61.944 A 15.885 15.885 0 0 0 316.68 62.041 A 15.712 15.712 0 0 0 320.51 61.599 A 11.011 11.011 0 0 0 325.8 58.621 A 15.098 15.098 0 0 0 328.923 53.844 Q 329.731 51.929 330.181 49.629 A 26.253 26.253 0 0 0 330.24 49.321 L 338.64 1.441 L 365.16 1.441 L 356.76 49.321 A 55.762 55.762 0 0 1 353.799 60.151 A 42.566 42.566 0 0 1 348.18 70.321 Q 341.76 78.841 332.46 83.041 A 47.91 47.91 0 0 1 315.781 87.117 A 56.9 56.9 0 0 1 312 87.241 Q 299.149 87.241 290.963 81.167 A 27.165 27.165 0 0 1 289.2 79.741 A 24.322 24.322 0 0 1 281.512 66.394 A 36.995 36.995 0 0 1 280.68 58.321 Q 280.68 53.881 281.52 49.321 L 289.92 1.441 Z"
              id="3"
              vector-effect="non-scaling-stroke"
            />
            <path
              d="M 371.88 1.441 L 443.4 1.441 L 439.68 22.561 L 417.12 22.561 L 405.84 86.401 L 379.2 86.401 L 390.48 22.561 L 368.16 22.561 L 371.88 1.441 Z"
              id="4"
              vector-effect="non-scaling-stroke"
            />
            <path
              d="M 540.6 1.441 L 573.12 1.441 L 558.12 86.401 L 531.6 86.401 L 539.04 44.161 L 518.52 86.401 L 495.72 86.401 L 490.08 43.801 L 482.64 86.401 L 456 86.401 L 471 1.441 L 503.64 1.441 L 513.36 52.561 L 540.6 1.441 Z"
              id="6"
              vector-effect="non-scaling-stroke"
            />
            <path
              d="M 638.04 22.561 L 608.04 22.561 L 606.24 33.121 L 632.64 33.121 L 629.04 53.161 L 602.64 53.161 L 600.48 65.161 L 630.48 65.161 L 626.76 86.401 L 570.12 86.401 L 585.12 1.441 L 641.76 1.441 L 638.04 22.561 Z"
              id="7"
              vector-effect="non-scaling-stroke"
            />
          </g>
        </svg>
      </div> */}
      <div className="container about-content">
        <div className="about-content-img about-flex">
          <img src={pic1}></img>
        </div>
        <div className="about-flex about-content-p">
          <hr></hr>
          <p>
          Hello! I'm Ankit, a passionate Software Developer with a track record in building robust web applications. My expertise spans a wide spectrum, from front-end technologies like React, Redux, and JavaScript to back-end technologies such as Node.js, SQL, AWS services. I strive to learn new things every time. This mindset of continuous learning has been instrumental in my career growth and enables me to adapt to new challenges with ease. I bring creativity and efficiency to every project.
            <br></br>
            <br></br>
            This portfolio is a representation of all that I've learned and
            accomplished as a web developer, coding and how my critical thinking
            skills have evolved over the course. I love designing websites and
            am looking for more opportunities.
          </p>
        </div>
      </div>
      <br></br>
      <br></br>

      {/* <div className="about-timeline">
        <div class="timeline">
          <ul>
          
            <li>
              <span>HackerRank</span>
              <div class="content">
                <p>
                  <b>4★</b> in problem solving Skills
                </p>
              </div>
            </li>
            <li>
              <span>HackaThon</span>
              <div class="content">
                <p>
                  Participation in Internal selection for Smart India HackaThon
                </p>
              </div>
            </li>
            <li>
              <span>NLP Expo</span>
              <div class="content">
                <p>
                  Made <b>Virtual assistant</b> using google speech recognition.
                </p>
              </div>
            </li>
            <li>
              <span>Coding Sprint</span>
              <div class="content">
                <p>
                  Participation in 2days HackaThon Coding sprint organised by
                  Vakil Search.
                </p>
              </div>
            </li>
            <li>
              <span>SRM Hackathon 7.0</span>
              <div class="content">
                <p>
                  Designed a <b>QR-based quality control system</b>
                  <a
                    href="https://github.com/ank-2222/lab-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FiExternalLink style={{ color: "#1a1c23" }} />
                  </a>{" "}
                  for the healthcare department.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div> */}
    </div>
  );
}

export default About;
